/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Swissness from './layouts/Swissness';
import NewReadingMaterial from './layouts/NewReadingMaterial';
import GeneralCampaign from './layouts/GeneralCampaign';
import NewReadingRound from './layouts/NewReadingRound';
import NewFromBookWorld from './layouts/NewFromBookWorld';
import ReadingChallenge from './layouts/ReadingChallenge';
import Events from './layouts/Events';
import Polls from './layouts/Polls';
import ImageOnly from './layouts/ImageOnly';
import ThaliaGeneralPositive from './layouts/ThaliaGeneralPositive';
import ThaliaGeneralNegative from './layouts/ThaliaGeneralNegative';
import ThaliaSimplePositive from './layouts/ThaliaSimplePositive';
import ThaliaSimpleNegative from './layouts/ThaliaSimpleNegative';
import ThaliaReadingRound from './layouts/ThaliaReadingRound';
import ThaliaReadingMaterial from './layouts/ThaliaReadingMaterial';
import ThaliaEvent from './layouts/ThaliaEvent';

export const layoutRegistry = {
	items: {
		swissness: Swissness,
		new_reading_material: NewReadingMaterial,
		general_campaign: GeneralCampaign,
		new_reading_round: NewReadingRound,
		new_from_book_world: NewFromBookWorld,
		reading_challenge: ReadingChallenge,
		events: Events,
		polls: Polls,
		image_only: ImageOnly,
		thalia_general: ThaliaGeneralPositive,
		thalia_general_neg: ThaliaGeneralNegative,
		thalia_simple: ThaliaSimplePositive,
		thalia_simple_neg: ThaliaSimpleNegative,
		thalia_reading_round: ThaliaReadingRound,
		thalia_reading_material: ThaliaReadingMaterial,
		thalia_event: ThaliaEvent,
	},

	setLayout(key, component) {
		this.items[key] = component;
	},

	getLayout(key) {
		return this.items[key];
	},

	getLayoutKeys() {
		const isOrell = !!app.forum.attribute('isOrell');
		return Object.keys(this.items).filter((key) => isOrell ^ key.startsWith('thalia'));
	},
};

export default class Banner extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const { banner } = this.attrs;

		let layout = banner.setup()?.layout;

		if (!layout) {
			// default back to image only
			layout = 'image_only';
		}

		const Layout = layoutRegistry.getLayout(layout);

		return (
			<div className="Banner">
				<Layout {...this.attrs} />
			</div>
		);
	}
}
